<template>
  <!--新闻详情-->

  <div>

  <div class="box">
    <div class="news-title on-show-two">{{ row.title }}</div>
    <div class="news-read-time">
      <span>阅读{{ row.views_count }}</span>
      <span>{{ row.create_time_ago }}</span>
    </div>
    <div class="fdown" v-if="row.files.length>0">
      文件下载
      
      <p v-for="(file,key) in row.files" :key="key" @click="download(file)"><svg t="1646357503345" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="2092" width="16" height="16"><path d="M828.975746 894.125047 190.189132 894.125047c-70.550823 0-127.753639-57.18542-127.753639-127.752616L62.435493 606.674243c0-17.634636 14.308891-31.933293 31.93227-31.933293l63.889099 0c17.634636 0 31.93227 14.298658 31.93227 31.933293l0 95.821369c0 35.282574 28.596292 63.877843 63.87682 63.877843L765.098927 766.373455c35.281551 0 63.87682-28.595268 63.87682-63.877843l0-95.821369c0-17.634636 14.298658-31.933293 31.943526-31.933293l63.877843 0c17.634636 0 31.933293 14.298658 31.933293 31.933293l0 159.699212C956.729385 836.939627 899.538849 894.125047 828.975746 894.125047L828.975746 894.125047zM249.938957 267.509636c12.921287-12.919241 33.884738-12.919241 46.807049 0l148.97087 148.971893L445.716876 94.89323c0-17.634636 14.300704-31.94762 31.933293-31.94762l63.875796 0c17.637706 0 31.945573 14.312984 31.945573 31.94762l0 321.588299 148.97087-148.971893c12.921287-12.919241 33.875528-12.919241 46.796816 0l46.814212 46.818305c12.921287 12.922311 12.921287 33.874505 0 46.807049L552.261471 624.930025c-1.140986 1.137916-21.664416 13.68365-42.315758 13.69286-20.87647 0.010233-41.878806-12.541641-43.020816-13.69286L203.121676 361.13499c-12.922311-12.933567-12.922311-33.884738 0-46.807049L249.938957 267.509636 249.938957 267.509636z" p-id="2093" fill="#1296db"></path></svg> {{ file.name }}</p>
    </div>
    <div class="news-content" v-html="row.content">
    </div>
    <div v-if="row.id==960">

          <div :key="sqindex" v-for="(sqvalue,sqindex) in shequList">
            <van-divider>{{sqindex}}</van-divider>
            <van-cell-group>
                <van-cell  @click="sqdonwload(sqindex,'')"   :title="sqindex" is-link> 
                </van-cell>
                <van-cell @click="sqdonwload(sqindex,sqcvalue)" :key="sqcindex" v-for="(sqcvalue,sqcindex) in sqvalue" :title="sqcvalue" is-link> 
                </van-cell>
            </van-cell-group>
            </div> 
    </div>
    <!-- <div class="vote" @click="jump(row.vote_url)" >投票入口</div> -->
    <iframe width="100%" style="border: none;outline: none" v-if="row.vote_url" height="2000px" :src="row.vote_url" ></iframe>
    <!-- <div class="news-content" v-html="xx.content"></div> -->


      <div class="zan-box">
        <span class="zan-num">{{row.zan_list.length}}赞</span>
        <img
          class="user-zan-face"
          v-for="(item,i) in row.zan_list"
          :key="i"
          :src="item.user_face"
          alt
        />
      </div>

    <div class="comments-box">
      <div class="comments-box-title">评论</div>
      <div class="comments-list-box" v-if="row.comment_list.length>0">
        <div class="comments-list" v-show="item.is_show==1||item.is_admin" v-for="(item,i) in  row.comment_list" :key="i" @click="onToUserComment(item)" @touchstart="showCommentDeleteButton(item,i)"
                @touchend="emptyTime">
          <div>
            <div class="user-face">
              <img :src="item.user_face" />
              <!-- <img src="../../../assets/images/activity/pic-logo1@2x.png" alt srcset /> -->
            </div>
            <div class="user-info">
              <div class="user-names">{{item.user_name}}</div>
              <div class="look-info">{{item.create_time_ago }}</div>
            </div>
          </div>
          <div class="comments-content" v-if="item.to_user_name==null">{{ item.content }}</div>
          <div class="comments-content" v-else>
            <span style="color:#ccc">
              回复
              <span style="color:#000">{{ item.to_user_name }}:</span>
            </span>
            {{ item.content }}
          </div>
        </div>
      </div>
    </div>



    <van-action-sheet
        v-model="ltShow"
        :actions="ltActions"
        cancel-text="取消"
        @select="onLtSelect"
        close-on-click-action
        @cancel="ltShow=false"
    />

    <div class="share-box share-right">
      <div class="share-right-texts" @click="show_share_panel = true">分享给好友</div>
    </div>

    <div class="shareShow" v-if="showWxShare" @click="onShareCancel">
      <div>
        <h2>点击分享给好友</h2>
      </div>
    </div>


    <van-popup v-model="show_share_panel" position="bottom" :style="{ height: '30%' }">
      <div class="share-panel">
        <div class="share-title">请选择分享方式</div>
        <!--<div class="share-desc">朋友通过你分享的页面成功报名后，你可获得对应的佣金。佣金可在会员中心-分销订单里查看</div>-->
        <div class="share-ul">
          <div class="share-weixin" @click="shareWeixinFriend">
            <p>微信好友</p>
          </div>
          <div class="share-timeline" @click="shareWeixinTimeLine">
            <p>朋友圈</p>
          </div>
          <div class="share-copy" v-clipboard:copy="copy_text"
               v-clipboard:success="function(){copySuccess();show_share_panel=false }">
            <p>复制链接</p>
          </div>
        </div>
      </div>
    </van-popup>


    <van-action-sheet
  v-model="sheetCommentShow"
  :actions="sheetCommentActions"
  cancel-text="取消"
  close-on-click-action
  @cancel="onSheetCancel"
  @select="onSelect"
/>


  </div>

    <div class="send-comments">
      <van-field
        v-model="message"
        maxlength="50"
        :placeholder="commentsPlaceholder"
        show-word-limit
      />
      <div class="zan-btn">
        <img @click="onAddZan" v-if="!row.is_zan" src="../../../assets/images/activity/icon-active-de0.png" alt />
        <img @click="onRemoveZan" v-else src="../../../assets/images/activity/icon-active-de1.png" alt />

      </div>
    </div>
  </div>

</template>
<style scoped>
.vote{
  width: 80%;
  height: 50px;
  line-height: 50px;
  font-size: 20px;
  text-align: center;
  color: #F55202;
  border-radius: 10px;
  margin: 20px auto;
  border: 1px solid #F55202;
}
.box {
  width: 7.1rem;
  height: 100vh;
  margin: 0.2rem auto;
}


.share-box {
  position: fixed;
  right: 20px;
  /*top: 60%;*/
  top: 53%;
  z-index: 8;
}

.share-right {
  margin-right: -50px;
  width: 153px;
  height: 49px;
  line-height: 49px;
  background:linear-gradient(
      90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%);
  box-shadow: 0px 2px 6px 0px rgba(255, 173, 25, 1);
  border-radius: 46px;
  text-align: center;
}

.share-right-text {
  width: 124px;
  height: 44px;
  font-size: 14px;
  padding-top: 4px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 22px;
}

.share-right-texts {
  width: 124px;
  height: 44px;
  font-size: 14px;
  padding-top: 4px;
  font-weight: 400;
  color: rgba(255, 255, 255, 1);
  line-height: 40px;
}

.fdown {
  background-color: #f8f8f8;
  border-radius: 10px;
  padding: 10px;
  margin-top: 10px;
}

.fdown p {
  color: #2b7aff;
  text-decoration: blink;
  font-size: 16px;
  margin-top: 20px;
}

.news-title {

  font-size: 20px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(34, 34, 34, 1);
}

.news-read-time {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  margin-top: 0.2rem;
}

.news-content {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  margin-top: 20px;
  color: rgba(34, 34, 34, 1);
  line-height: 28px;
}

.news-content >>> img {
  max-width: 100% !important;
}

.news-content >>> video {
  max-width: 100% !important;
}


.zan-btn {
  width: 17px;
  height: 17px;
  margin-left: 13.5px;
  margin-right: 10px;
}
.zan-btn img {
  width: 17px;
  height: 17px;
}
.send-comments >>> .van-cell {
  margin-left: 10px;
  padding: 5px 8px;
  background: #eeeeee;
  border-radius: 5px;
}
.send-comments >>> .van-field__control {
  padding-right: 40px;
}
.send-comments >>> .van-field__word-limit {
  position: absolute;
  top: 0;
  right: 0;
}
.send-comments {
  width: 100%;
  height: 1rem;
  border-top: 1px solid #f5f5f5;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.12);
  position: fixed;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.comments-content {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 20px;
  margin-left: 32px;
}
.comments-list-box {
  width: 6.7rem;
  border-radius: 10px;
  background: #fff;
  justify-content: space-between;
  margin-bottom: 14.5px;
  padding: 10px;
}
.comments-list {
  background: #fff;
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}
.comments-box {
  width: 7.1rem;

  margin: 10px auto;
  padding-bottom: 50px;
}
.user-info {
  margin-left: 5px;
  float: left;
}
.user-info view {
  height: 50px;
  line-height: 50px;
}
.user-names {
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
}
.comments-box-title {
  height: 26px;
  font-size: 19px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 26px;
  margin: 8px 0;
}

.interactive-box {
  width: 7.1rem;
  margin: 20px auto;
  margin-bottom: 10px;
}
.interactive-item {
  width: 6.7rem;
  height: 1.1rem;
  border-radius: 10px;
  background: #f3f3f3;
  display: flex;
  padding: 10px;
  justify-content: space-between;
  margin-bottom: 14.5px;
}
.interactive-item img {
  width: 40px;
  height: 40px;
  margin-right: 0.18rem;
}
.interactive-solid {
  width: 1px;
  height: 100%;
  background: rgba(0, 0, 0, 0.08);
  margin: 0 0.16rem;
}
.interactive-info {
  flex: 1;
}
.interactive-btn {
  width: 1.5rem;
  height: 0.5rem;
  background: linear-gradient(
    90deg,
    rgba(254, 200, 53, 1) 0%,
    rgba(255, 173, 25, 1) 100%
  );
  border-radius: 5px;
  text-align: center;
  line-height: 0.5rem;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(255, 255, 255, 0.85);
}
.interactive-info-title {
  height: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  line-height: 20px;
}
.interactive-info-desc {
  height: 33px;
  font-size: 12px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(153, 153, 153, 1);
  line-height: 16.5px;
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}

.zan-box {
  display: flex;
  flex-direction: row-reverse;
  padding: 0 10px;
}
.user-zan-face {
  width: 22px;
  height: 22px;
  border-radius: 22px;
  margin-right: 4px;
}
.zan-num {
  padding: 1px 5px;
  background: rgba(231, 231, 231, 1);
  border-radius: 22px;
  font-size: 11px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(102, 102, 102, 1);
  line-height: 20px;
}


.comment-box {
  background: #fff;
}
.comment-desc {
  padding: 0 0.3rem;
  margin-bottom: 0.1rem;
}
.comment-item-list {
  display: flex;
  overflow-x: scroll;
}
.item-desc {
  margin-right: 0.2rem;
}
.item-desc img {
  height: 2rem;
}
.comment-img-list {
  padding: 0 0.2rem;
  overflow-x: scroll;
}

.comment-img {
  display: block;
  height: 80px;
  width: 100px;
  margin-right: 0.1rem;
  float: left;
}
.comment-header {
  padding: 10px 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #fff;
}
.comment-num {
  text-align: center;
}
.comment {
  padding: 10px 10px;
  display: flex;
  align-items: center;
  background: #fff;
  margin-top: 10px;
}
.comment-btn {
  height: 28px;
  line-height: 28px;
  text-align: center;
  color: #ccc;
  border: 1px solid #cccccc;
  border-radius: 10px;
  width: 60%;
}

.user-face {
  height: 32px;
  width: 32px;
  border-radius: 50%;
  overflow: hidden;
  float: left;
}
.user-face img {
  height: 32px;
  width: 32px;
}
.comment-user-face {
  height: 32px;
  width: 32px;
  border-radius: 50%;
  overflow: hidden;
  float: left;
  background: #ccc;
}
.comment-user-face img {
  width: 32px;
  height: 32px;
}
</style>
<script>
import Vue from 'vue';
import {ActionSheet,Field,Toast,ImagePreview} from 'vant';
import LoginDialog from '@/components/LoginDialog.vue';
import {getTimeFormat} from "../../../utils/date.js";

Vue.use(ImagePreview).use(Field).use(Toast);
Vue.use(ActionSheet);
import jquery from 'jquery';

jquery.fn.longPress = function (fn) {
  let timeout = 0;
  const $this = this;
  console.log('jquery.fn.longPress')
  for (let i = 0; i < $this.length; i++) {
    $this[i].addEventListener('touchstart', () => {
      timeout = setTimeout(fn, 800); // 长按时间超过800ms，则执行传入的方法
    }, false);
    $this[i].addEventListener('touchend', () => {
      clearTimeout(timeout); // 长按时间少于800ms，不会执行传入的方法
    }, false);
  }
};

export default {
  name: 'NewsDetail',
  components: {
    ImagePreview,LoginDialog},
  data: function () {
    return {
      ltShow: false,
      copy_text: '',
      to_comment_id:'',
      shequList:[],
      commentIndex:0,
      sheetCommentShow:false,
      message:'',
      commentsPlaceholder:"",
      showWxShare: false,
      show_share_panel: false,
      ltImgSrc: '',
      ltImgName: '',
      ltActions: [{name: '保存图片'}],
      row: {
        id: 0,
        title: '-',
        content: '',
        files: '',
        comment_list:[],
      },
      share_data: {},
       Loop:null,
      sheetCommentActions: [{ name: '删除评论' }],
    }
  },
  filters: {
    getTimeFormat: getTimeFormat
  },
  mounted() {
    let that = this;
    document.title = '新闻详情';
    this.row.id = this.$route.query.id;
    this.fetch();
    if(this.row.id = 960){
      // this.get960()
    }


    document.addEventListener("keydown", function(event) {
      // console.log(event.key)
      if(event.key=='Enter'){
        that.onCommentSend()
      }
    });

    window.rbMessage = function (data) {
      if (data == 'showShare') {
        that.show_share_panel = true;
      }
    }


  },
  watch: {},
  destroyed() {
  },
  methods: {
    onQuestion() {
      console.log('onQuestion')
    },
    onLtSelect(item) {
      let that = this;
      switch (item.name) {
        case '保存图片':
          console.log(that.ltImgSrc, that.ltImgName);
          appEvent({
            name: 'downloadPic',
            query: {
              'filename': that.ltImgName,
              'url': that.ltImgSrc
            }
          });
          break;
      }
    },
    onToUserComment(item){
      console.log(item)
      this.commentsPlaceholder='@'+item.user_name
      this.to_comment_id=item.id
    },
    showCommentDeleteButton(item,i){
      console.log(item,i)
      clearTimeout(this.Loop); //再次清空定时器，防止重复注册定时器
      this.Loop = setTimeout(
        function() {
          // console.log(e)
          if(item.is_admin){
            console.log("删除")
            this.commentIndex=i
            this.sheetCommentShow=true
            // this.$emit("deleteComment",i)
          }
        }.bind(this),
        800
      );
    },

    emptyTime() {
      clearTimeout(this.Loop); //清空定时器，防止重复注册定时器
    },
    get960(){
      let that = this;
      that.$api.get(
        "/api/Dshequscore/areatree",
        {   },
        res => { 
          this.shequList = res.data
        }
      )
      
    },
    onAddZan() {
      let that = this;
      that.$api.post(
        "/api/activity/zanadd",
        { topic_id: this.row.id,type:'cms' },
        res => {
          // this.fetch();
          this.row.zan_list.push(res.data)
          this.row.is_zan=true
        },
        res => {
          if (res.code == 401 || res.code == 402) {
            if (window.isApp()) {
              rbLink(
                {
                  name: "login",
                  query: {}
                },
                "replace"
              );
              return false;
            }
            that.loginShow = true
            // this.$emit("loginStatus", true);
          } else {
            Toast(res.msg);
          }
        }
      );
    },
    onRemoveZan() {
      let that = this;
      that.$api.post(
        "/api/activity/zanremove",
        { topic_id: this.row.id,type:'cms' },
        res => {
          // that.row = res.data;
          this.row.zan_list.map((item,i)=>{
            if(res.data.user_id==item.user_id){
              this.row.zan_list.splice(i,1)
            }
          })
          this.row.is_zan=false
          // this.fetch();
        },
        res => {
          if (res.code == 401 || res.code == 402) {
            if (window.isApp()) {
              rbLink(
                {
                  name: "login",
                  query: {}
                },
                "replace"
              );
              return false;
            }
            that.loginShow = true
            // this.$emit("loginStatus", true);
          } else {
            Toast(res.msg);
          }
        }
      );
    },

    onCommentSend(){
      let that=this
      // console.log('发送评论',this.item,this.message)
      that.$api.get(
        "/api/activity/commentAdd",
        {
          topic_id: this.row.id,
          content:this.message,
          type:'cms',
          to_comment_id:this.to_comment_id
        },
        res => {
         console.log(res)
         this.row.comment_list.push(res.data)
         this.message=''
         this.to_comment_id=0,
         this.commentsPlaceholder="已有" + this.row.comment_list.length + "条回复,参与互动 !";
        },
        res => { 
          if (res.code == 401 || res.code == 402) {
            if (window.isApp()) {
              rbLink(
                {
                  name: "login",
                  query: {}
                },
                "replace"
              );
              return false;
            }
            that.loginShow = true;
          } else {
            Toast(res.msg);
          }
        }
      );

    },
    sqdonwload(province,city){

      appEvent({
        name: 'downloadFile',
        query: {
          name: province+city+'.pdf',
          url: 'https://ccago.oss-cn-hangzhou.aliyuncs.com/shequ-results/'+encodeURIComponent(province+city)+'.pdf'
        }
      });
    },
    download(file) {
      // 判断如果是PDF文件 直接在页面中打开 vue-pdf??

      appEvent({
        name: 'downloadFile',
        query: {
          name: file.name,
          url: file.url,
        }
      });
    },
    jump(url) {
      // 判断如果是PDF文件 直接在页面中打开 vue-pdf??

      appEvent({
        name: 'downloadFile',
        query: {
          name: '',
          url: url,
        }
      });
    },
    fetch() {
      let that = this;
      that.$api.post('/api/cms/detail', {
        id: that.row.id
      }, (res) => {
        that.row = res.data.data;
        that.share_data = res.data.share_data;
        that.copy_text = res.data.share_data.url;

        that.commentsPlaceholder =
            "已有" + res.data.data.comment_list.length + "条回复,参与互动 !";


        that.wxShare(res.data.share_data.title, res.data.share_data.desc, res.data.share_data.url, res.data.share_data.pic_url);

        if (window.isApp()) {
          setTimeout(() => {
            jquery('img').each(function () {
              jquery(this).longPress(() => {
                console.log('longPress', jquery(this).attr('src'));
                that.ltImgSrc = jquery(this).attr('src')
                that.ltImgName = jquery(this).attr('title')
                that.ltShow = true;
              });
            })
          }, 500);
          return false;
        }

      }, (res) => {
        Toast.fail(res.msg);
      })
    },

    onShareCancel() {
      this.showWxShare = false;
    },


    shareWeixinFriend() {
      console.log('shareWeixinFriend')
      let that = this;
      if (window.isApp()) {
        appEvent({
          name: 'shareWeixinFriend',
          query: that.share_data
        });
      } else {
        this.showWxShare = true;
        this.show_share_panel = false;
      }
    },
    onSelect(action,index){
      console.log(action,index)
      switch (action.name){
        case '删除评论':
           this.CommentDetele()
        break;
      }
    },
    CommentDetele(){
      //删除评论
      let that=this
      let id=this.row.comment_list[this.commentIndex].id
      console.log(id,this.commentIndex)
      that.$api.get(
        "/api/activity/commentDelete",
        {id:id},
        res => {
          this.row.comment_list.splice(that.commentIndex,1)
          Toast('删除成功!');
          this.commentsPlaceholder="已有" + this.row.comment_list.length + "条回复,参与互动 !";
        },
        res => {
          Toast(res.msg);
        }
      );
    },
    onSheetCancel() {
      // Toast('取消');
    },
    shareWeixinTimeLine() {
      let that = this;
      if (window.isApp()) {
        appEvent({
          name: 'shareWeixinTimeLine',
          query: that.share_data
        });
      } else {
        this.showWxShare = true;
        this.show_share_panel = false;

      }
    }

  }
}
</script>



// WEBPACK FOOTER //
// NewsDetail.vue?4ec67250